import React from "react";
import { useLocalization } from "@fluent/react";
import PropTypes from "prop-types";
import { Button, ResponsiveFlex } from "@narmi/design_system";
import { ContextForm } from "cerulean";
import FormContent from "./FormContent";
import HeaderWithSteps from "../../../HeaderWithSteps";

const WireTransferForm = ({ cancel, limits, onSubmit, Header = null }) => {
  const { l10n } = useLocalization();
  return (
    <ResponsiveFlex gapSize="xl">
      <HeaderWithSteps
        headerText={l10n.getString("heading-wire-title")}
      />
      {Header}
      <FormContent limits={limits} />
      <div className="alignChild--center--center">
        <Button
          onClick={cancel}
          label={l10n.getString("button-back")}
          kind="negative"
        />
        <ContextForm.Action onSubmit={onSubmit} dangerouslyDisableShowLoading>
          <div style={{ marginLeft: "auto" }}>
            <Button
              label={l10n.getString("button-review")}
              testId="submit-wire-transfer"
            />
          </div>
        </ContextForm.Action>
      </div>
    </ResponsiveFlex>
  );
};
WireTransferForm.propTypes = {
  cancel: PropTypes.func,
  limits: PropTypes.object,
  onSubmit: PropTypes.func,
  Header: PropTypes.element,
};

export default WireTransferForm;
